enum IndexFlags {
  INDISPONIVEL = '000000000',
  CORRECAO_PELO_SISTEMA = '100000000',
  JUROS_DO_SISTEMA = '010000000',
  CORRECAO_PELO_SITE = '001000000',
  CONSULTA_EXTERNA = '000100000',
  CORRECAO_POR_API = '000010000',
  CONVERSAO = '000001000',
  HONORARIOS_CPC = '000000100',
  FINANCIAMENTO = '000000010',
  PLANO_GRATUITO = '000000001',
  CDI_INDEX = 66,
}

export default IndexFlags;
